export default {
    'login.form.system.title': '登录安智管家',
    'login.form.system.subtitle': 'CMIC ENRIC',
    'login.form.title': '登录安智管家',
    'login.form.subtitle': '登录安智管家',
    'login.form.userName.errMsg': '用户名不能为空',
    'login.form.password.errMsg': '密码不能为空',
    'login.form.login.errMsg': '登录出错，轻刷新重试',
    'login.form.login.success': '欢迎使用',
    'login.form.userName.placeholder': '请输入用户名',
    'login.form.password.placeholder': '请输入密码',
    'login.form.login': '登录',
};
